import { NavLink, Outlet } from 'react-router-dom';
import { brand } from '@/lib/brand';
import { useAuthMe, useLogout } from '@/hooks/useAuth';
import { PlaceholderBanner } from './PlaceholderBanner';

const nav = [
  { to: '/', label: 'Dashboard', end: true },
  { to: '/enquiries', label: 'Enquiries' },
  { to: '/events', label: 'Events' },
  { to: '/quotes', label: 'Quotes' },
  { to: '/quotes/quick', label: 'Quick quote' },
  { to: '/invoices', label: 'Invoices' },
  { to: '/calendar', label: 'Calendar' },
  { to: '/catalog', label: 'Rate list' },
  { to: '/clients', label: 'Clients' },
  { to: '/import-review', label: 'Import review' },
  { to: '/staff', label: 'Staff' },
  { to: '/settings', label: 'Settings' },
] as const;

export function AppShell() {
  const { data } = useAuthMe();
  const logout = useLogout();
  const user = data?.user;

  return (
    <div className="min-h-dvh">
      <PlaceholderBanner />
      <header className="sticky top-0 z-40 border-b border-[var(--border)] bg-[color-mix(in_oklab,var(--color-dome-forest)_92%,transparent)] text-dome-sand backdrop-blur-md">
        <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3">
          <div className="min-w-0">
            <p className="font-display text-lg font-semibold tracking-tight text-dome-sand sm:text-xl">
              {brand.productFull}
            </p>
            <p className="truncate text-xs text-dome-sand/70">{brand.org}</p>
          </div>
          <div className="flex items-center gap-3 text-sm">
            {user ? (
              <>
                <span className="hidden text-dome-sand/80 sm:inline">
                  {user.fullName}
                </span>
                <button
                  type="button"
                  className="rounded-md bg-dome-brass px-3 py-1.5 font-medium text-dome-ink"
                  onClick={() => logout.mutate()}
                >
                  Sign out
                </button>
              </>
            ) : null}
          </div>
        </div>
        <nav className="mx-auto flex max-w-7xl gap-1 overflow-x-auto px-3 pb-2">
          {nav.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={'end' in item ? item.end : false}
              className={({ isActive }) =>
                [
                  'whitespace-nowrap rounded-md px-3 py-1.5 text-sm transition',
                  isActive
                    ? 'bg-dome-sand/15 text-dome-sand'
                    : 'text-dome-sand/65 hover:bg-dome-sand/10 hover:text-dome-sand',
                ].join(' ')
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="mx-auto max-w-7xl px-4 py-6 animate-fade-up">
        <Outlet />
      </main>
    </div>
  );
}
